export default __webpack_public_path__ + "static/media/arrow-right-svgrepo-com.c35e314a.svg";